import { memo } from 'react';
import { Box, Typography } from '@lingoda/ui';
import type { AppointmentStatus } from '@lingoda/monolith-graphql';
import {
    getAppointmentStatusColor,
    getAppointmentStatusIcon,
    getAppointmentStatusText,
} from '../../helpers/bookingClassElement';

interface Props {
    status: AppointmentStatus;
    isUpcoming?: boolean;
    isPast: boolean;
}

const ClassListItemStatusComponent = ({ isUpcoming = false, status, isPast }: Props) => {
    const displayContent = getAppointmentStatusText(status, isPast, isUpcoming);
    const displayIcon = !isPast && isUpcoming ? null : getAppointmentStatusIcon(status);

    return (
        <Box
            sx={(theme) => ({
                display: 'flex',
                width: '100%',
                alignItems: 'center',
                color: getAppointmentStatusColor(theme, status, !isPast && isUpcoming),
            })}
        >
            <Typography variant="subtitle2">{displayContent}</Typography>
            <Typography variant="subtitle2" display="flex" alignItems="center">
                {displayIcon}
            </Typography>
        </Box>
    );
};

export const ClassListItemStatus = memo(ClassListItemStatusComponent);
